import { Route } from '@angular/router';
import { PAGE_LAYOUT, AuthenticationGuard } from '@aksia/infrastructure';
import { LoginPageContent } from './pages/login/login.content.page';
import { ForgotPasswordPageContent } from './pages/forgot-password/forgot-password.content.page';
import { ResetPasswordPageContent } from './pages/reset-password/reset-password.content.page';
import { VerifyLocationPageContent } from './pages/verify-location/verify-location.content.page';
import { DummyPageContent } from './pages/dummy/dummy.page';
import { SessionRequiredPageContent } from './pages/session-required/session-required.content.page';
import { SetupAuthenticatorPageContent } from './pages/setup-authenticator/setup-authenticator.content.page';
import { SecurityPageContent } from './pages/security/security.content.page';
export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    data: {
      masterLayoutSettings: {
        tag: 'app',
        type: PAGE_LAYOUT.CENTER,
      },
    },
    loadComponent: () => LoginPageContent,
  },
  {
    path: 'forgot-password',
    data: {
      masterLayoutSettings: {
        tag: 'app',
        type: PAGE_LAYOUT.CENTER,
      },
    },
    loadComponent: () => ForgotPasswordPageContent,
  },
  {
    path: 'dummy',
    data: {
      masterLayoutSettings: {
        tag: 'app',
        type: PAGE_LAYOUT.CENTER,
      },
    },
    canActivate: [AuthenticationGuard],
    loadComponent: () => DummyPageContent,
  },
  {
    path: 'verify-location',
    data: {
      masterLayoutSettings: {
        tag: 'app',
        type: PAGE_LAYOUT.CENTER,
      },
    },
    loadComponent: () => VerifyLocationPageContent,
  },
  {
    path: 'setup-authenticator',
    data: {
      masterLayoutSettings: {
        tag: 'app',
        type: PAGE_LAYOUT.CENTER,
      },
    },
    loadComponent: () => SetupAuthenticatorPageContent,
  },
  {
    path: 'security',
    data: {
      masterLayoutSettings: {
        tag: 'app',
        type: PAGE_LAYOUT.CENTER,
      },
    },
    loadComponent: () => SecurityPageContent,
  },
  {
    path: 'reset-password',
    data: {
      masterLayoutSettings: {
        tag: 'app',
        type: PAGE_LAYOUT.CENTER,
      },
    },
    loadComponent: () => ResetPasswordPageContent,
  },
  {
    path: 'session-required',
    data: {
      masterLayoutSettings: {
        tag: 'app',
        type: PAGE_LAYOUT.CENTER,
      },
    },
    loadComponent: () => SessionRequiredPageContent,
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
